/* istanbul ignore file */
import { datadogRum } from '@datadog/browser-rum';
import { datadogIsEnabled } from './datadog.utils';

export const datadog: typeof datadogRum = datadogIsEnabled()
  ? datadogRum
  : new Proxy(datadogRum, {
      get(target: any, propKey) {
        switch (typeof target[propKey]) {
          case 'function':
            // we mock all the functions with an empty one
            return function () {}; // eslint-disable-line @typescript-eslint/no-empty-function
          default:
            return null;
        }
      },
    });
